const TRUE = 'true';
const ON = 'on';
export const TEACHERS_AUTH_TOKEN_KEY = 'teachers_auth_token';
export const STUDENTS_AUTH_TOKEN_KEY = 'students_auth_token';
export const USERS_EMAIL = 'users_email';
export const ORGANIZATIONS_AUTH_TOKEN_KEY = 'organizations_auth_token';
export const WEB_SOCKET_TOKEN_KEY = 'web_socket_token';
export const SHOW_TUTORIAL = 'showTutorial';
export const SHOW_TUTORIAL_FLAG_START = 'start';
export const SHOW_TUTORIAL_FLAG_END = 'end';
export const PLAN_INTRODUCTION_FLAG = 'plan_introduction';
export const PLAN_INTRODUCTION_FLAG_ON = ON;
export const LEFTOVER_FLAG = 'leftover';
export const LEFTOVER_FLAG_ON = ON;
export const SHOWED_TUTORIAL = 'showed_tutorial';
export const BILLING_FLAG = 'billing_flag';
export const SIGNUP_REDIRECT_FLAG = 'signup_redirect_flag';
export const NEW_USER = 'new_user';
export const NEW_USER_ON = ON;
export const PACKAGE_ID = 'package_id';
export const PACKAGE_PRICE = 'package_price';
export const STRIPE_PUBLIC_KEY = 'stripe_public_key';
export const DISPLAY_LANGUAGE = 'display_language';
export const PROVIDER = 'provider';
export const SNS_FLG_ON = ON;
export const SNS_FLG_OFF = 'off';
export const SNS_FLG = 'sns_flg';
export const SNS_NEW_USER_REGISTERING_FLAG = 'sns_new_user_registering_flag';
export const SNS_NEW_USER_REGISTERING_FLAG_ON = ON;
export const SNS_USER_FLAG = 'sns_user_flag';
export const SNS_USER_FLAG_ON = ON;
export const SNS_PASSWORD_ON = ON;
export const PASSWORD_FLG = 'password_flg';
export const DEFAULT_NOT_SET_JAPANESE_CONVERSACTION_LEVEL_KEY = 'default_not_set';
export const DEFAULT_NOT_SET_JAPANESE_CONVERSACTION_LEVEL_VALUE = TRUE;
export const TEACHER_APPLE_NAME_FLG_KEY = 'teacher_apple_name_flg';
export const TEACHER_APPLE_NAME_FLG_VAL = ON;
export const TEACHER_IS_FIRST_GOOGLE_LOGIN = 'teacher_google_picture_flg';
export const TEACHER_IS_FIRST_GOOGLE_LOGIN_VALUE = TRUE;
export const ALL_TUTORIAL_SEEN = 'all_tutorials_seen';
export const ALL_TUTORIAL_SEEN_VALUE = TRUE;
export const GENERAL_TUTORIAL_SEEN = 'general_tutorial_seen';
export const GENERAL_TUTORIAL_SEEN_VALUE = TRUE;
export const PROFILE_TUTORIAL_SEEN = 'profile_tutorial_seen';
export const PROFILE_TUTORIAL_SEEN_VALUE = TRUE;
export const RESERVATION_TUTORIAL_SEEN = 'reservation_tutorial_seen';
export const RESERVATION_TUTORIAL_SEEN_VALUE = TRUE;
export const CONVERSATION_TUTORIAL_SEEN = 'conversation_tutorial_seen';
export const CONVERSATION_TUTORIAL_SEEN_VALUE = TRUE;
export const ENCOURAGEMENT_TUTORIAL_SEEN = 'encouragement_tutorial_seen';
export const ENCOURAGEMENT_TUTORIAL_SEEN_VALUE = TRUE;
export const HELP_CENTER_TUTORIAL_SEEN = 'help_center_tutorial_seen';
export const HELP_CENTER_TUTORIAL_SEEN_VALUE = TRUE;
export const PLUS_PROMOTION_MODAL = 'plus_promotion_modal';
export const PLUS_PROMOTION_MODAL_SEEN = TRUE;
export const PLUS_PROMOTION_MODAL_LAST_SEEN = 'plus_promotion_modal_last_seen';
export const PROFILE_EMAIL = 'profile_email';
export const PROFILE_PHONE = 'profile_phone';
export const PROFILE_COUNTRY = 'profile_country';
export const PROFILE_PICTURE = 'profile_picture';
export const PROFILE_NAME = 'profile_name';
export const PROFILE_NAME_JA = 'profile_name_ja';
export const PROFILE_NATIONALITY = 'profile_nationality';
export const PROFILE_TIMEZONE = 'profile_timezone';
export const PROFILE_LEVEL = 'profile_level';
export const PROFILE_TAGS = 'profile_tags';
export const PROFILE_PREFERRED_NAME = 'profile_preferredName';
export const PROFILE_GENDER = 'profile_gender';
export const PROFILE_CUSTOM_GENDER = 'profile_gender';
export const PROFILE_DESIRED_CONDITION = 'profile_desiredCondition';
export const PROFILE_PREFECTURE = 'profile_prefecture';
export const PROFILE_PURPOSES = 'profile_purposes';
export const PROFILE_CONVERSATION_LEVEL = 'profile_conversationLevel';
export const PROFILE_EMPLOYMENT_HOPE = 'profile_employmentHope';
export const PROFILE_SELF_INTRODUCTION = 'profile_selfIntroduction';
export const PROFILE_UNSAVED_CHANGES = 'profile_unsaved_changes';
// 世界側ユーザーのIssues（無料/有料プラン）の有効期限判断用
export const CURRENT_PLAN_EXPIRED = 'currnet_plan_expired';
export const CURRENT_PLAN_EXPIRATION_DATE = 'currnet_plan_date';
export const CURRENT_PLAN_EXPIRED_ON = TRUE;
